<template>
  <div style="width: 100%" :style="'height:' + (this.$store.state.windowHeight - 150) + 'px'">
    <el-space wrap>
      <el-select v-model="obj.blockValue" @change="handleSelectChange">
        <template #prefix>
          <el-icon class="el-input__icon">
            <tickets />
          </el-icon>
        </template>
        <el-option v-for="item in obj.blockList" :key="item.value" :label="item.label" :value="item.value">
        </el-option>
      </el-select>
      <el-select v-model="obj.selectedDayValue" @change="handleSelectDayChange" style="width:110px">
        <el-option v-for="item in obj.selectDayList" :key="item.value" :label="item.label" :value="item.value">
        </el-option>
      </el-select>
      <el-button type="primary" @click="handleRefresh">
        <el-icon class="el-input__icon">
          <refresh />
        </el-icon>
      </el-button>
    </el-space>
    <el-table :data="obj.dataList" style="width: 100%" height="100%" :cell-style="cellStyle"
      :header-row-style="headerRowStyle" empty-text=" " @row-click="handleRowClick">
      <el-table-column width="110" fixed prop="name" label="" align="right" />
      <el-table-column width="110" align="right" v-for="(data, index) in obj.nameList" :key="index" :prop="data"
        :label="data" />
    </el-table>
  </div>
</template>
<script>
import { getCurrentInstance, onMounted, onUnmounted, reactive } from 'vue'
import { useStore } from 'vuex'
import { useRoute, useRouter } from 'vue-router'
import { http } from '../util/http'
import { findObjByField } from '../util/base'
export default {
  setup() {
    const vueEvent = getCurrentInstance()?.appContext.config.globalProperties.vueEvent
    const store = useStore()
    const router = useRouter()
    const route = useRoute()
    const obj = reactive({
      nameList: [],
      dataList: [],
      blockList: [
        { value: 0, label: '金属' },
        { value: 1, label: '黑色系' },
        { value: 2, label: '能源化工' },
        { value: 3, label: '农产品' },
      ],
      blockValue: 0,
      blockLabel: '金属',
      selectDayList: [
        {
          value: '5',
          label: '最近 5日'
        },
        {
          value: '10',
          label: '最近 10日'
        },
        {
          value: '20',
          label: '最近 20日'
        },
        {
          value: '30',
          label: '最近 30日'
        },
        {
          value: '40',
          label: '最近 40日'
        },
        {
          value: '50',
          label: '最近 50日'
        },
        {
          value: '60',
          label: '最近 60日'
        },
        // {
        //   value: '0',
        //   label: '全部'
        // }
      ],
      selectedDayValue: '5',
    })

    // 生命周期函数 挂载完毕事件
    onMounted(() => {
      vueEvent.emit('navbarMenuIdxEvent', '7')
      vueEvent.emit('sidebarMenuIdxEvent', '')
      getQueryInfo()
    })

    // 生命周期函数 挂载销毁事件
    onUnmounted(() => {
    })

    // 获取URL传值
    const getQueryInfo = () => {
      if (route.query.block != null && route.query.block != '') {
        obj.blockLabel = route.query.block
        if (obj.blockLabel === '贵金属' || obj.blockLabel === '有色金属') {
          obj.blockLabel = '金属'
        } else if (obj.blockLabel === '黑色系') {
          obj.blockLabel = '黑色系'
        } else if (obj.blockLabel === '能源' || obj.blockLabel === '化工') {
          obj.blockLabel = '能源化工'
        } else if (obj.blockLabel === '油脂油料' || obj.blockLabel === '农产品') {
          obj.blockLabel = '农产品'
        }
        const tempObj = findObjByField(obj.blockList, 'label', obj.blockLabel)
        obj.blockValue = tempObj.value
        requestData()
      } else {
        renderView()
      }
    }

    // 渲染画面
    const renderView = () => {
      // 是否存在缓存
      if (store.state.correlationData === '') {
        // 无缓存，从后台请求数据
        requestData()
      } else {
        // 有缓存，设定页面状态
        getStore()
      }
    }

    // 后台获取数据
    const requestData = () => {
      let formData = new FormData()
      formData.append("block", obj.blockLabel)
      formData.append("range", obj.selectedDayValue)
      http({
        url: `/correlation`,
        method: 'post',
        data: formData
      }).then((res) => {
        console.log(res)
        processData(res)
        setStore()
      })
    }

    // 加工处理数据
    const processData = (res) => {
      // 对应golang map接受顺序打乱问题, 使用后台返回的res.data.sort做为表头数据
      var tempList = []
      if (res.data.sort.length !== 0) {
        for (var key of res.data.sort) {
          tempList.push(key) // 设置表头数据
        }
      }
      for (var i in res.data.data) {
        for (var k in res.data.data[i]) {
          res.data.data[i][k] = res.data.data[i][k].toFixed(2) // 保留2位小数
        }
        res.data.data[i].name = tempList[i] // 增加第一列
      }
      obj.nameList = tempList
      obj.dataList = res.data.data
    }

    // 保存至store
    const setStore = () => {
      var storeObj = {
        'blockValue': obj.blockValue,
        'blockLabel': obj.blockLabel,
        'nameList': obj.nameList,
        'dataList': obj.dataList,
        'selectedDayValue': obj.selectedDayValue
      }
      store.commit('setCorrelationData', storeObj) // 缓存数据
    }

    // 获取Store
    const getStore = () => {
      obj.blockValue = store.state.correlationData.blockValue
      obj.blockLabel = store.state.correlationData.blockLabel
      obj.nameList = store.state.correlationData.nameList
      obj.dataList = store.state.correlationData.dataList
      obj.selectedDayValue = store.state.correlationData.selectedDayValue
    }

    // 下拉框选择事件
    const handleSelectChange = (value) => {
      // 下拉框value转为label
      const tempObj = findObjByField(obj.blockList, 'value', value)
      obj.blockLabel = tempObj.label
      requestData()
    }

    // 下拉框选择事件
    const handleSelectDayChange = (value) => {
      requestData()
    }

    // 按钮刷新事件
    const handleRefresh = (e) => {
      requestData()
    }

    // 表格行点击事件
    const handleRowClick = (row) => {
      // console.log(row)
      let name = row.name
      store.commit('setCurrentContract', name)
      router.push(`/candlestick?name=${name}`)
    }

    // 设置表格单元格样式
    const cellStyle = (row, column, rowIndex, columnIndex) => {
      for (var i in obj.nameList) {
        if (parseFloat(row.row[obj.nameList[i]]) === 0 && row.columnIndex === parseFloat(i) + 1) {
          return { color: 'black' }
        } else if (parseFloat(row.row[obj.nameList[i]]) === 1 && row.columnIndex === parseFloat(i) + 1) {
          return { color: 'black' }
        } else if (parseFloat(row.row[obj.nameList[i]]) > 0 && row.columnIndex === parseFloat(i) + 1) {
          return { color: 'red' }
        } else if (parseFloat(row.row[obj.nameList[i]]) < 0 && row.columnIndex === parseFloat(i) + 1) {
          return { color: 'green' }
        }
      }
    }

    // 设置表格头部样式
    const headerRowStyle = (row, column, rowIndex, columnIndex) => {
      return 'font-size:14px; color:#606266'
    }

    return {
      obj,
      store,
      handleSelectChange,
      handleSelectDayChange,
      handleRefresh,
      handleRowClick,
      cellStyle,
      headerRowStyle,
    }
  }
}
</script>
<style lang="scss" scoped></style>
